import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Notification = ({ message, type, duration = 5000 }) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(false);
        }, duration);

        return () => clearTimeout(timer);
    }, [duration]);

    if (!isVisible) return null;

    const getNotificationStyle = () => {
        const baseStyle = {
            position: 'fixed',
            top: '20px',
            right: '20px',
            padding: '15px 20px',
            borderRadius: '4px',
            color: 'white',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            zIndex: 1000,
            animation: 'slideIn 0.5s ease-out',
            maxWidth: '300px',
            wordBreak: 'break-word',
        };

        switch (type) {
            case 'success':
                return { ...baseStyle, backgroundColor: '#4CAF50' };
            case 'error':
                return { ...baseStyle, backgroundColor: 'red' };
            case 'warning':
                return { ...baseStyle, backgroundColor: '#FF9800' };
            case 'info':
                return { ...baseStyle, backgroundColor: '#2196F3' };
            default:
                return { ...baseStyle, backgroundColor: '#333' };
        }
    };

    return (
        <div style={getNotificationStyle()}>
            {message}
        </div>
    );
};

Notification.propTypes = {
    message: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
    duration: PropTypes.number,
};

export default Notification;
